export const DrawRequestsTestIds = {
  // DrawRequests.js
  REQUEST_BUTTON: 'draw-requests.request-button',

  // DrawRequestDrawerContent.js
  REQUESTED_AMOUNT_INPUT: 'draw-request-form.requested-amount-input',
  APPROVED_AMOUNT_INPUT: 'draw-request-form.approved-amount-input',
  STATUS_SELECT: 'draw-request-form.status-select',
  NOTES_INPUT: 'draw-request-form.notes-input',
};
